import React from 'react';

/**
 * MicrosoftMarkIcon — the Microsoft 2x2 four-square brand glyph as inline SVG.
 * React port of dview's programmatic MicrosoftMarkIcon.java (same four brand
 * colors), so the "Sign in with Microsoft" button reads identically across
 * viewers. Rendered inline (no bitmap asset) so it themes cleanly and scales.
 *
 * Official Microsoft mark colors: red #F25022 (TL), green #7FBA00 (TR),
 * blue #00A4EF (BL), yellow #FFB900 (BR), with a small gap between squares.
 */
const MicrosoftMarkIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 21"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    className="login-oauth-button__mark"
  >
    <rect x="1" y="1" width="9" height="9" fill="#F25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
    <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
    <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
  </svg>
);

export default MicrosoftMarkIcon;
